import Feedback from '../feedback';

/**
 * Create the action
 */

const { thunk, request, success, error } = Feedback.index((fetch) => {
    return fetch.get('/feedback');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
